import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	subCategory: null,
	error: "",
	loading: false,
};

// ADD_subCategory
export const addSubCategory = createAsyncThunk(
	"subCategory/addSubCategory",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `subCategory/`,
				data: {
					...values,
				},
			});
			toast.success("Sub-Category added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Sub-Category try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_subCategory
export const deleteSubCategory = createAsyncThunk(
	"subCategory/deleteSubCategory ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `subCategory/${id}`,
			});

			toast.success("Sub-Category deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Sub-Category try again");
			console.log(error.message);
		}
	}
);

// subCategory_DETAILS
export const loadSinglePublicHoliday = createAsyncThunk(
	"subCategory/loadSinglePublicHoliday",
	async (id) => {
		try {
			const data = await axios.get(`subCategory/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// subCategoryS
export const getAllSubCategory = createAsyncThunk(
	"subCategory/getAllSubCategory",
	async () => {
		try {
			const { data } = await axios.get(`subCategory/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateSubCategory = createAsyncThunk(
	"subCategory/updateSubCategory",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `subCategory/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Sub-Category updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Sub-Category try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const subCategorySlice = createSlice({
	name: "subCategory",
	initialState,
	reducers: {
		clearSubCategory: (state) => {
			state.subCategory = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllSubCategory ======

		builder.addCase(getAllSubCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllSubCategory.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllSubCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addSubCategory  ======

		builder.addCase(addSubCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addSubCategory.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addSubCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for subCategory ======

		builder.addCase(updateSubCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateSubCategory.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateSubCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteSubCategory  ======

		builder.addCase(deleteSubCategory.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteSubCategory.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteSubCategory.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default subCategorySlice.reducer;
export const { clearSubCategory } = subCategorySlice.actions;
